import { gql } from '@apollo/client'

export const SEARCH_PRODUCTS = gql`
  query ($productName: String!, $configuration: ArtistProductType!) {
    searchProducts(productName: $productName, configuration: $configuration) {
      total
      products {
        dv_entity_id
        primaryArtistName
        name
        type
        release_date
      }
    }
  }
`
